/* ----------------- Hooks --------------- */
import { useHint } from "../hooks/useHint";

/* ----------------- Components --------------- */
import { HintAccordion } from "../components/HintAccordion";

/* ----------------- Types --------------- */
import type { BaseItemSchema } from "@memorang/types/src/session/new-session";

const HintContainer = ({ item }: { item: BaseItemSchema }) => {
	const { hints, loading, streaming, getHint } = useHint({
		item,
	});

	return (
		<HintAccordion
			hints={hints}
			loading={loading}
			streaming={streaming}
			itemId={item.id!}
			getHint={getHint}
		/>
	);
};

export default HintContainer;
